import styled from "styled-components";
import {
	DESKTOP_M_BP,
	TABLET_M_BP,
	MOBILE_L_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
export const MentorItemCompanyLogoWrapper = styled.div`
	height: 32px;
	width: 80px;
`;
export const MentorItemContentWrapper = styled.div`
	padding: 1.5rem;
	display: flex;
	gap: 1rem;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.mentor-item-text-wrapper {
		display: flex;
		gap: 0.5rem;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.mentor-item-text-wrapper p,
	h6 {
		text-align: center;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		height: 100%;
		padding: 1rem;
		align-items: flex-start;
		justify-content: center;
		.mentor-item-text-wrapper {
			align-items: flex-start;
		}
		.mentor-item-text-wrapper p,
		h6 {
			text-align: start;
		}
	}
`;
export const MentorsCardsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1.5rem;
	height: max-content;
	row-gap: 1.5rem;
	justify-content: center;
	.mentor-grid-item {
		padding: 0;
		min-height: 372px;
		width: 294px;
		display: flex;
		flex-direction: column;
		z-index: 1;
	}
	.mentor-profile-image {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}
	.mentor-company-logo {
		object-fit: contain;
		width: 100%;
		height: 100%;
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		justify-content: center;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.mentor-grid-item {
			display: flex;
			flex-direction: row;
			width: 100%;
			min-height: 123px;
		}
		.mentor-profile-image {
			object-fit: cover;
			width: 100%;
		}
	}
`;

export const MentorItemImageWrapper = styled.div`
	overflow: hidden;
	border-top-left-radius: 0.5rem;
	border-top-right-radius: 0.5rem;
	height: 230px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		min-width: 30%;
		width: 30%;
		border-top-right-radius: 0rem;
		border-bottom-left-radius: 0.5rem;
		height: 100%;
	}
`;
export const AccordionItemHeadingWrapper = styled.div`
	display: flex;
	align-items: center;
`;
export const MentorGridWrapper = styled.div`
	padding: 5rem 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 4rem;

	position: relative;
	contain: paint;
	.mentor-grid-accordion-content {
		padding-top: 1rem;
	}
	.mentor-grid-vertical-tabs {
		width: 100%;
	}
	.text-center {
		text-align: center;
	}
	.mentor-grid-title-wrapper {
		width: 30%;
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 2.5rem 0;
		margin: 0;
		gap: 2.5rem;
		.mentor-grid-vertical-tabs,
		.course-line-graphic {
			display: none;
		}
		.accordion-heading {
			text-align: center;
			margin: 0 0 1rem 0;
			display: inline-block;
			width: 100%;
		}
		.mentor-grid-title-wrapper {
			width: 40%;
		}
		.mentor-grid-accordion {
			width: 100%;
		}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.mentor-grid-title-wrapper {
			width: 80%;
		}
	}
	@media only screen and (min-width: ${TABLET_M_BP}px) {
		.mentor-grid-accordion,
		.course-footer {
			display: none;
		}
	}
`;
export const LoadMoreCTAWrapper = styled.div`
	.show-more-mentors-link {
		border: none;
		background: transparent;
		box-shadow: none;
	}
	margin: 2.5rem 1rem 0rem;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
`;
